import React, { useContext } from "react";
import { NewtworkContext } from "../../../Layouts/Mint";
import { useWizard } from "react-use-wizard";
import { Wizard } from "react-use-wizard";
import IntroScreen from "./IntroScreen";
import Rules from "./Rules";
import Paired from "./Paired";
import Final from "./Final";
import { StepWrapper } from "../Components";

const Play: React.FC = () => {
  const network = useContext(NewtworkContext);
  const { handleStep, nextStep } = useWizard();

  handleStep(() => {
    network?.setActiveStep(3);
  });
  return (
    <section className="flex items-center justify-center py-12">
      <Wizard wrapper={<StepWrapper />}>
        <IntroScreen />
        <Rules />
        <Paired />
        <Final onPlayComplete={nextStep} />
      </Wizard>
    </section>
  );
};

export default Play;
